module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/CallToActionSection/car-model-ac8c66d7bd1c64b85085cbffb4343e92.png";